import { Pill, type PillSize, type PillVariant } from "@src/appV2/redesign/system/ui-components";

interface IcAgreementPillProps {
  size?: PillSize;
  variant?: PillVariant;
}

export function IcAgreementPill(props: IcAgreementPillProps) {
  const { size = "small", variant = "outlined" } = props;

  return (
    <Pill
      size={size}
      variant={variant}
      label="Sign agreement"
      iconType="locked-filled"
      backgroundColor={(theme) => theme.palette.background.tertiary}
      outlineColor={(theme) => theme.palette.intent?.neutral.border}
      color={(theme) => theme.palette.intent?.neutral.text}
      iconColor={(theme) => theme.palette.intent?.neutral.icon}
      sx={{
        width: "fit-content",
      }}
    />
  );
}
